import {Organisation} from '.'

export const getShortName = (org: Organisation) => {
  if (!org) return '...'
  return `${org.name}`
}
